// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"00bb5158","82":"16fa57f6","208":"9ee9ba54","253":"b9f8dc23","488":"996c6a8c","572":"f9ef0f60","671":"a0ab305e","784":"91a96050","815":"d286b40b","885":"3c760a5c"}[chunkId] + ".chunk.js";
};